module.exports = __webpack_public_path__ + "438e3424436bba764e0012551f8fd87e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/outbreaks_filled.png
 ** module id = 1071
 ** module chunks = 0
 **/